var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configData && _vm.configData.isShow === 1
    ? _c("div", { staticClass: "txt_tab borderPadding" }, [
        _c(
          "div",
          { staticClass: "radio_row-item" },
          [
            _c("el-row", { staticClass: "c_label" }, [
              _c("span", { staticClass: "labelwidth" }, [
                _vm._v(_vm._s(_vm.configData.title)),
              ]),
            ]),
            _c(
              "el-row",
              {},
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { type: "button" },
                    on: {
                      change: function ($event) {
                        return _vm.radioChange($event)
                      },
                    },
                    model: {
                      value: _vm.configData.tabVal,
                      callback: function ($$v) {
                        _vm.$set(_vm.configData, "tabVal", $$v)
                      },
                      expression: "configData.tabVal",
                    },
                  },
                  _vm._l(_vm.configData.list, function (radio, key) {
                    return _c("el-radio", { key: key, attrs: { label: key } }, [
                      radio.icon
                        ? _c("span", {
                            staticClass: "iconfont-diy iconfont",
                            class: radio.icon,
                          })
                        : _c("span", [_vm._v(_vm._s(radio.val))]),
                    ])
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }